export enum AttributionSourceType {
  MEMBER = 'MEMBER',
  RELATIONSHIP = 'RELATIONSHIP',
  CUSTOM = 'CUSTOM',
  TABLELIST = 'TABLELIST',
  WIDGET = 'WIDGET',
  RESERVATION_REQUEST_FORM = 'RESERVATION_REQUEST_FORM',
  GUEST_LIST_REQUEST_FORM = 'GUEST_LIST_REQUEST_FORM',
  FAST_PASS = 'FAST_PASS',
  IMPORT = 'IMPORT',
  NONE = 'NONE',
  WALKUP = 'WALKUP',
}

export enum AttributionSourceAction {
  MERGE = 'MERGE',
}

export enum AttributionSourceTypeName {
  MEMBER = 'Staff',
  RELATIONSHIP = 'Promoter',
  CUSTOM = 'Custom',
  TABLELIST = 'Tablelist',
  WIDGET = 'Widget',
  RESERVATION_REQUEST_FORM = 'Widget - Reservation Request Form',
  GUEST_LIST_REQUEST_FORM = 'Widget - Guest List Request Form',
  FAST_PASS = 'Tablelist Fast Pass',
  IMPORT = 'Import',
  NONE = 'None',
  WALKUP = 'Walk Up',
}

export enum AttributionSourceEvent {
  CREATED = 'TL_ATTRIBUTION_SOURCE_CREATED',
  UPDATED = 'TL_ATTRIBUTION_SOURCE_UPDATED',
}

export const AttributionSources = {
  NONE_SOURCE: {
    id: AttributionSourceType.NONE,
    type: AttributionSourceType.NONE,
    name: 'None',
  },
  WIDGET_SOURCE: {
    id: AttributionSourceType.WIDGET,
    type: AttributionSourceType.WIDGET,
    name: 'Widget',
  },
  TABLELIST_SOURCE: {
    id: AttributionSourceType.TABLELIST,
    type: AttributionSourceType.TABLELIST,
    name: 'Tablelist',
  },
  FAST_PASS_SOURCE: {
    id: AttributionSourceType.FAST_PASS,
    type: AttributionSourceType.FAST_PASS,
    name: 'Tablelist Fast Pass',
  },
  RESERVATION_REQUEST_FORM_SOURCE: {
    id: AttributionSourceType.RESERVATION_REQUEST_FORM,
    type: AttributionSourceType.RESERVATION_REQUEST_FORM,
    name: 'Reservation Form',
  },
  WALKUP_SOURCE: {
    id: AttributionSourceType.WALKUP,
    type: AttributionSourceType.WALKUP,
    name: 'Walk Up',
  },
}

export const defaultAttributionSource = AttributionSources.NONE_SOURCE

export enum AttributionSourceErrorMessages {
  ORGANIZATION_REQUIRED = 'organization is required',
  NAME_REQUIRED = 'name is required',
  VALUE_REQUIRED = 'value is required',
  TYPE_REQUIRED = 'type is required',
  TYPE_INVALID = 'type is invalid',
  ATTRIBUTION_SOURCE_ALREADY_EXISTS = 'attribution source already exists',
  VENUES_MUST_BE_AN_ARRAY = 'venues must be an array',
  VENUES_DO_NOT_BELONG_TO_ORGANIZATION = 'venues do not belong to organization',
}
